export * from './list'
export enum JobDepartments {
    Accounting = 'Accounting',
    Administrative = 'Administrative',
    ArtsAndDesign = 'Arts and Design',
    BusinessDevelopment = 'Business Development',
    CommunitySocialServices = 'Community and Social Services',
    Consulting = 'Consulting',
    Education = 'Education',
    Engineering = 'Engineering',
    Entrepreneurship = 'Entrepreneurship',
    Finance = 'Finance',
    HealthcareServices = 'Healthcare Services',
    HumanResources = 'Human Resources',
    InformationTechnology = 'Information Technology',
    Legal = 'Legal',
    Marketing = 'Marketing',
    MediaCommunication = 'Media and Communication',
    MilitaryProtectiveServices = 'Military and Protective Services',
    Operations = 'Operations',
    ProductManagement = 'Product Management',
    ProgramProjectManagement = 'Program and Project Management',
    Purchasing = 'Purchasing',
    QualityAssurance = 'Quality Assurance',
    RealEstate = 'Real Estate',
    Research = 'Research',
    Sales = 'Sales',
    Support = 'Support'
}

export enum JobTitles {
    Owner = 'Owner',
    Founder = 'Founder',
    CoFounder = 'Co-founder',
    Investor = 'Investor',
    Partner = 'Partner',
    CXO = 'CXO',
    VP = 'VP',
    Director = 'Director',
    Manager = 'Manager',
    Senior = 'Senior',
    Entry = 'Entry',
    Training = 'Training',
    Unpaid = 'Unpaid',
    Others = 'Others'
}

export const contactStatusColors = {
    Published: '#22B254',
    InternalPublished: '#FFC22D',
    Unassigned: '#F14D4D',
    Assigned: '#F14D4D',
    Updated: '#F14D4D',
    Activated: '#F14D4D',
    Deactivated: '#F14D4D'
}

export enum DATA_SOURCE {
    Salutary = 'Salutary',
    AladdinB2B = 'AladdinB2B'
}
